// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__zZVGE","content":"modal_content__crzOT","header":"modal_header__SBBp2","body":"modal_body__CZJdM"};